/**
 * Models generated from "Model and Storage" and models extracted from services.
 * To generate entity use syntax:
 * Apperyio.EntityAPI("<model_name>[.<model_field>]");
 */
export var models = {
    "String": {
        "type": "string"
    },
    "Number": {
        "type": "number"
    },
    "Any": {
        "type": "any"
    },
    "Function": {
        "type": "Function"
    },
    "Promise": {
        "type": "Promise"
    },
    "Boolean": {
        "type": "boolean"
    },
    "Observable": {
        "type": "Observable"
    },
    "HostGator_HostGator_RESORT_RESORT_ListarGruposNahuelitos_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/RESORT/RESORT/ListarGruposNahuelitos"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "Fecha": {
                                "type": "string"
                            },
                            "idiomaBase": {
                                "type": "string"
                            },
                            "id_Tipo_Actividad": {
                                "type": "number",
                                "default": null
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "array",
                                "items": [{
                                    "type": "object",
                                    "properties": {
                                        "actividad": {
                                            "type": "string"
                                        },
                                        "id_actividad": {
                                            "type": "number",
                                            "default": null
                                        }
                                    }
                                }]
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_RESORT_RESORT_ReservarActividadExtra_put": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/RESORT/RESORT/ReservarActividadExtra"
            },
            "method": {
                "type": "string",
                "default": "put"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "CantPersonas": {
                                "type": "number",
                                "default": null
                            },
                            "Observaciones": {
                                "type": "string"
                            },
                            "Huesped": {
                                "type": "string"
                            },
                            "ApellidoNombre": {
                                "type": "string"
                            },
                            "FechaInicio": {
                                "type": "string"
                            },
                            "Email": {
                                "type": "string"
                            },
                            "Habitacion": {
                                "type": "number",
                                "default": null
                            },
                            "TelefonoContacto": {
                                "type": "string"
                            },
                            "id_actividad": {
                                "type": "number",
                                "default": null
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "code": {
                                "type": "number",
                                "default": 200
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_RESORT_RESORT_ReservarPiscina_New_put": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/RESORT/RESORT/ReservarPiscina_New"
            },
            "method": {
                "type": "string",
                "default": "put"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "TelefonoContacto": {
                                "type": "string"
                            },
                            "Email": {
                                "type": "string"
                            },
                            "Observaciones": {
                                "type": "string"
                            },
                            "Huesped": {
                                "type": "string"
                            },
                            "ApellidoNombre": {
                                "type": "string"
                            },
                            "FechaInicio": {
                                "type": "string"
                            },
                            "CantPersonasRoom": {
                                "type": "number",
                                "default": null
                            },
                            "Habitacion": {
                                "type": "number",
                                "default": null
                            },
                            "FechaCheckIn": {
                                "type": "string"
                            },
                            "CantPersonas": {
                                "type": "number",
                                "default": null
                            },
                            "FechaCheckOut": {
                                "type": "string"
                            },
                            "Tipo": {
                                "type": "string"
                            },
                            "id_actividad": {
                                "type": "number",
                                "default": null
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "code": {
                                "type": "number",
                                "default": 200
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_AABB_Desayuno_HorariosDesayunoDisponibles_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/AABB/Desayuno/HorariosDesayunoDisponibles"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "FechaCheckin": {
                                "type": "string"
                            },
                            "FechaCheckout": {
                                "type": "string"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "object",
                                "properties": {
                                    "data": {
                                        "type": "object",
                                        "properties": {
                                            "updateCount1": {
                                                "type": "number",
                                                "default": 0
                                            },
                                            "resultSet1": {
                                                "type": "array",
                                                "items": [{
                                                    "type": "object",
                                                    "properties": {
                                                        "Rango": {
                                                            "type": "string"
                                                        },
                                                        "idRango": {
                                                            "type": "string"
                                                        }
                                                    }
                                                }]
                                            }
                                        }
                                    },
                                    "status": {
                                        "type": "string",
                                        "default": "success"
                                    }
                                }
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_RESORT_RESORT_ReservarNahuelitos_put": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/RESORT/RESORT/ReservarNahuelitos"
            },
            "method": {
                "type": "string",
                "default": "put"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "id_actividad": {
                                "type": "number",
                                "default": null
                            },
                            "Observaciones": {
                                "type": "string"
                            },
                            "TelefonoContacto": {
                                "type": "string"
                            },
                            "CantPersonas": {
                                "type": "number",
                                "default": null
                            },
                            "Huesped": {
                                "type": "string"
                            },
                            "FechaCheckIn": {
                                "type": "string"
                            },
                            "Habitacion": {
                                "type": "number",
                                "default": null
                            },
                            "Email": {
                                "type": "string"
                            },
                            "FechaInicio": {
                                "type": "string"
                            },
                            "ApellidoNombre": {
                                "type": "string"
                            },
                            "FechaCheckOut": {
                                "type": "string"
                            },
                            "Tipo": {
                                "type": "string"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "code": {
                                "type": "number",
                                "default": 200
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_Varios_Controles_ControlHuesped_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/Varios/Controles/ControlHuesped"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "Tipo": {
                                "type": "string"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "object",
                                "properties": {
                                    "code": {
                                        "type": "number",
                                        "default": 404
                                    }
                                }
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HotelApp_login_service": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/db/login"
            },
            "method": {
                "type": "string",
                "default": "post"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "username": {
                                "type": "string"
                            },
                            "password": {
                                "type": "string"
                            }
                        }
                    },
                    "query": {
                        "type": "object",
                        "properties": {}
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string",
                                "default": "application/json"
                            },
                            "X-Appery-Database-Id": {
                                "type": "string",
                                "default": "{HotelApp_settings.database_id}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "sessionToken": {
                                "type": "string"
                            },
                            "_id": {
                                "type": "string"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {}
                    }
                }
            }
        }
    },
    "HostGator_HostGator_AABB_ReservasRestaurant_CancelarReservaAABB_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/AABB/ReservasRestaurant/CancelarReservaAABB"
            },
            "method": {
                "type": "string",
                "default": "put"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "idReserva": {
                                "type": "number",
                                "default": null
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "code": {
                                "type": "number",
                                "default": 200
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_RESORT_RESORT_CancelarReservaResort_put": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/RESORT/RESORT/CancelarReservaResort"
            },
            "method": {
                "type": "string",
                "default": "put"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "id_reserva": {
                                "type": "number",
                                "default": null
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "code": {
                                "type": "number",
                                "default": 404
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_AABB_Desayuno_ReservarDesayuno_New_put": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/AABB/Desayuno/ReservarDesayuno_New"
            },
            "method": {
                "type": "string",
                "default": "put"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "idRango": {
                                "type": "string"
                            },
                            "Huesped": {
                                "type": "string"
                            },
                            "TelefonoContacto": {
                                "type": "string"
                            },
                            "CantPersonas": {
                                "type": "number",
                                "default": null
                            },
                            "Observaciones": {
                                "type": "string"
                            },
                            "FechaHasta": {
                                "type": "string"
                            },
                            "idOpera": {
                                "type": "string"
                            },
                            "Email": {
                                "type": "string"
                            },
                            "FechaDesde": {
                                "type": "string"
                            },
                            "FechaNacimiento": {
                                "type": "string"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "code": {
                                "type": "number",
                                "default": 200
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_AABB_Carro_addToCart_put": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/AABB/Carro/addToCart"
            },
            "method": {
                "type": "string",
                "default": "put"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "idPDV": {
                                "type": "number",
                                "default": null
                            },
                            "cant": {
                                "type": "number",
                                "default": null
                            },
                            "idUsu": {
                                "type": "string"
                            },
                            "idPlato": {
                                "type": "number",
                                "default": null
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "array",
                        "items": [{
                            "type": "object",
                            "properties": {
                                "insert_id": {
                                    "type": "number",
                                    "default": null
                                }
                            }
                        }]
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_RESORT_SPA_Tipo_Spa_Unico_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/RESORT/SPA/Tipo_Spa_Unico"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "id_Tipo_Spa": {
                                "type": "number",
                                "default": null
                            },
                            "idiomaBase": {
                                "type": "string"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "object",
                                "properties": {
                                    "id_Tipo_Spa": {
                                        "type": "number",
                                        "default": 2
                                    },
                                    "Descripcion": {
                                        "type": "string",
                                        "default": "Con reserva previa"
                                    },
                                    "ClaseAppery": {
                                        "type": "string",
                                        "default": "FontPlayfairSubTitulo"
                                    },
                                    "Titulo": {
                                        "type": "string",
                                        "default": "RegeneraciÃ³n celular"
                                    },
                                    "Detalle": {
                                        "type": "string",
                                        "default": "Para sentir la acciÃ³n revitalizante de las sales marinas con sus componentes totalmente naturales y dejarse envolver por su delicado aroma."
                                    },
                                    "Foto": {
                                        "type": "string",
                                        "default": "assets/images/Tiposdespa-celular2.jpg"
                                    }
                                }
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_RESORT_RESORT_ListarActividadesExtra_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/RESORT/RESORT/ListarActividadesExtra"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "Fecha": {
                                "type": "string"
                            },
                            "id_Tipo_Actividad": {
                                "type": "number",
                                "default": null
                            },
                            "idiomaBase": {
                                "type": "string"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "array",
                                "items": [{
                                    "type": "object",
                                    "properties": {
                                        "id_actividad": {
                                            "type": "number",
                                            "default": null
                                        },
                                        "Actividad": {
                                            "type": "string"
                                        }
                                    }
                                }]
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_RESORT_RESORT_ActividadesExtraDisponibles_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/RESORT/RESORT/ActividadesExtraDisponibles"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "Actividad": {
                                "type": "number",
                                "default": null
                            },
                            "CantPersonas": {
                                "type": "number",
                                "default": null
                            },
                            "idiomaBase": {
                                "type": "string"
                            },
                            "Fecha": {
                                "type": "string"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "array",
                                "items": [{
                                    "type": "object",
                                    "properties": {
                                        "actividad": {
                                            "type": "string"
                                        },
                                        "id_actividad": {
                                            "type": "number",
                                            "default": null
                                        }
                                    }
                                }]
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_AABB_PDV_Datos_PDV_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/AABB/PDV/Datos_PDV"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "idPDV": {
                                "type": "number",
                                "default": null
                            },
                            "idiomaBase": {
                                "type": "string"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "array",
                                "items": [{
                                    "type": "object",
                                    "properties": {
                                        "Detalle": {
                                            "type": "string"
                                        },
                                        "PDV": {
                                            "type": "string"
                                        },
                                        "Horario": {
                                            "type": "string"
                                        },
                                        "id_PDV": {
                                            "type": "number",
                                            "default": null
                                        },
                                        "Activo": {
                                            "type": "number",
                                            "default": null
                                        },
                                        "ClaseAppery": {
                                            "type": "string"
                                        },
                                        "Descripcion": {
                                            "type": "string"
                                        },
                                        "Foto": {
                                            "type": "string"
                                        }
                                    }
                                }]
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_AABB_PDV_Dato_PDV_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/AABB/PDV/Dato_PDV"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "idPDV": {
                                "type": "number",
                                "default": null
                            },
                            "idiomaBase": {
                                "type": "string"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "object",
                                "properties": {
                                    "PDV": {
                                        "type": "string",
                                        "default": "Lobby Bar"
                                    }
                                }
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HotelApp_logout_service": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/db/logout"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {}
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Database-Id": {
                                "type": "string",
                                "default": "{HotelApp_settings.database_id}"
                            },
                            "X-Appery-Session-Token": {
                                "type": "string"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "headers": {
                        "type": "object",
                        "properties": {}
                    }
                }
            }
        }
    },
    "HostGator_HostGator_RESORT_RESORT_ReservarCanchas_put": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/RESORT/RESORT/ReservarCanchas"
            },
            "method": {
                "type": "string",
                "default": "put"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "FechaInicio": {
                                "type": "string"
                            },
                            "FechaCheckOut": {
                                "type": "string"
                            },
                            "Email": {
                                "type": "string"
                            },
                            "Tipo": {
                                "type": "string"
                            },
                            "FechaCheckIn": {
                                "type": "string"
                            },
                            "Huesped": {
                                "type": "string"
                            },
                            "CantPersonas": {
                                "type": "number",
                                "default": null
                            },
                            "ApellidoNombre": {
                                "type": "string"
                            },
                            "Habitacion": {
                                "type": "number",
                                "default": null
                            },
                            "Observaciones": {
                                "type": "string"
                            },
                            "id_actividad": {
                                "type": "number",
                                "default": null
                            },
                            "TelefonoContacto": {
                                "type": "string"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "code": {
                                "type": "number",
                                "default": 200
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_Varios_Controles_ControlFechaCheckOut_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/Varios/Controles/ControlFechaCheckOut"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "FechaReserva": {
                                "type": "string"
                            },
                            "FechaCheckIn": {
                                "type": "string"
                            },
                            "FechaCheckOut": {
                                "type": "string"
                            },
                            "Tipo": {
                                "type": "string"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "object",
                                "properties": {
                                    "code": {
                                        "type": "number",
                                        "default": 404
                                    }
                                }
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_AABB_Desayuno_HorariosPreferencia2_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/AABB/Desayuno/HorariosPreferencia2"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "idHorario": {
                                "type": "number",
                                "default": null
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "array",
                                "items": [{
                                    "type": "object",
                                    "properties": {
                                        "Horario": {
                                            "type": "string",
                                            "default": "10:20"
                                        },
                                        "id": {
                                            "type": "number",
                                            "default": 10
                                        }
                                    }
                                }]
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_Varios_Controles_ControlHuespedDesayuno_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/Varios/Controles/ControlHuespedDesayuno"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "Tipo": {
                                "type": "string"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "object",
                                "properties": {
                                    "code": {
                                        "type": "number",
                                        "default": 200
                                    }
                                }
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_Varios_Controles_Banners_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/Varios/Controles/Banners"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "idBanner": {
                                "type": "number",
                                "default": null
                            },
                            "idiomaBase": {
                                "type": "string"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "array",
                                "items": [{
                                    "type": "object",
                                    "properties": {
                                        "ClaseAppery": {
                                            "type": "string"
                                        },
                                        "Link": {
                                            "type": "string"
                                        }
                                    }
                                }]
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_RESORT_RESORT_ReservarPiscina_put": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/RESORT/RESORT/ReservarPiscina"
            },
            "method": {
                "type": "string",
                "default": "put"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "Habitacion": {
                                "type": "number",
                                "default": null
                            },
                            "CantPersonas": {
                                "type": "number",
                                "default": null
                            },
                            "Observaciones": {
                                "type": "string"
                            },
                            "FechaInicio": {
                                "type": "string"
                            },
                            "id_actividad": {
                                "type": "number",
                                "default": null
                            },
                            "ApellidoNombre": {
                                "type": "string"
                            },
                            "TelefonoContacto": {
                                "type": "string"
                            },
                            "Huesped": {
                                "type": "string"
                            },
                            "Email": {
                                "type": "string"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "code": {
                                "type": "number",
                                "default": 200
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_RESORT_RESORT_ReservarPiscinaNew_put": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/RESORT/RESORT/ReservarPiscinaNew"
            },
            "method": {
                "type": "string",
                "default": "put"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "Habitacion": {
                                "type": "number",
                                "default": null
                            },
                            "Observaciones": {
                                "type": "string"
                            },
                            "Departure": {
                                "type": "string"
                            },
                            "id_actividad": {
                                "type": "number",
                                "default": null
                            },
                            "CantPersonas": {
                                "type": "number",
                                "default": null
                            },
                            "Huesped": {
                                "type": "string"
                            },
                            "FechaInicio": {
                                "type": "string"
                            },
                            "CantPersonasRoom": {
                                "type": "number",
                                "default": null
                            },
                            "Tipo": {
                                "type": "string"
                            },
                            "Email": {
                                "type": "string"
                            },
                            "ApellidoNombre": {
                                "type": "string"
                            },
                            "TelefonoContacto": {
                                "type": "string"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "code": {
                                "type": "number",
                                "default": 200
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_RESORT_RESORT_CantPersonasResort_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/RESORT/RESORT/CantPersonasResort"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "CantPersonasRoom": {
                                "type": "number",
                                "default": null
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "array",
                                "items": [{
                                    "type": "object",
                                    "properties": {
                                        "idCantPersonas": {
                                            "type": "number",
                                            "default": null
                                        },
                                        "CantPersonas": {
                                            "type": "number",
                                            "default": null
                                        }
                                    }
                                }]
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_RESORT_RESORT_Golf_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/RESORT/RESORT/Golf"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "idiomaBase": {
                                "type": "string"
                            },
                            "id_Golf": {
                                "type": "number",
                                "default": null
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "array",
                                "items": [{
                                    "type": "object",
                                    "properties": {
                                        "id_Golf": {
                                            "type": "number",
                                            "default": null
                                        },
                                        "Horario": {
                                            "type": "string"
                                        },
                                        "Foto": {
                                            "type": "string"
                                        },
                                        "Descripcion": {
                                            "type": "string"
                                        },
                                        "ClaseAppery": {
                                            "type": "string"
                                        },
                                        "Titulo": {
                                            "type": "string"
                                        },
                                        "Detalle": {
                                            "type": "string"
                                        }
                                    }
                                }]
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_RESORT_RESORT_ActividadesIndoorDisponibles_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/RESORT/RESORT/ActividadesIndoorDisponibles"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "Fecha": {
                                "type": "string"
                            },
                            "idiomaBase": {
                                "type": "string"
                            },
                            "CantPersonas": {
                                "type": "number",
                                "default": null
                            },
                            "Actividad": {
                                "type": "number",
                                "default": null
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "array",
                                "items": [{
                                    "type": "object",
                                    "properties": {
                                        "id_actividad": {
                                            "type": "number",
                                            "default": null
                                        },
                                        "actividad": {
                                            "type": "string"
                                        }
                                    }
                                }]
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_RESORT_RESORT_ListarActividades_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/RESORT/RESORT/ListarActividades"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "id_Tipo_Actividad": {
                                "type": "number",
                                "default": null
                            },
                            "idiomaBase": {
                                "type": "string"
                            },
                            "Fecha": {
                                "type": "string"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "array",
                                "items": [{
                                    "type": "object",
                                    "properties": {
                                        "Actividad": {
                                            "type": "string"
                                        },
                                        "id_actividad": {
                                            "type": "number",
                                            "default": null
                                        }
                                    }
                                }]
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HotelApp_me_service": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/db/users/me"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {}
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Database-Id": {
                                "type": "string",
                                "default": "{HotelApp_settings.database_id}"
                            },
                            "X-Appery-Session-Token": {
                                "type": "string"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "object",
                                "properties": {
                                    "_id": {
                                        "type": "string"
                                    },
                                    "Huesped": {
                                        "type": "string"
                                    },
                                    "Tipo": {
                                        "type": "string"
                                    },
                                    "TelefonoContacto": {
                                        "type": "string"
                                    },
                                    "id_Opera": {
                                        "type": "string"
                                    },
                                    "acl": {
                                        "type": "object",
                                        "properties": {}
                                    },
                                    "Habitacion": {
                                        "type": "string"
                                    },
                                    "FechaNacimiento": {
                                        "type": "string"
                                    },
                                    "Bloqueo": {
                                        "type": "string"
                                    },
                                    "Email": {
                                        "type": "string"
                                    },
                                    "Titulo": {
                                        "type": "string"
                                    },
                                    "Insert": {
                                        "type": "string"
                                    },
                                    "_updatedAt": {
                                        "type": "string"
                                    },
                                    "Titular": {
                                        "type": "string"
                                    },
                                    "_createdAt": {
                                        "type": "string"
                                    },
                                    "Idioma": {
                                        "type": "string"
                                    },
                                    "Arrival": {
                                        "type": "string"
                                    },
                                    "Update": {
                                        "type": "string"
                                    },
                                    "CantPersonas": {
                                        "type": "number",
                                        "default": null
                                    },
                                    "Departure": {
                                        "type": "string"
                                    },
                                    "username": {
                                        "type": "string"
                                    }
                                }
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {}
                    }
                }
            }
        }
    },
    "HostGator_HostGator_AABB_ReservasRestaurant_PDVs_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/AABB/ReservasRestaurant/PDVs"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "Fecha": {
                                "type": "string"
                            },
                            "idServicio": {
                                "type": "number",
                                "default": null
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "array",
                                "items": [{
                                    "type": "object",
                                    "properties": {
                                        "PuntoVenta": {
                                            "type": "string"
                                        },
                                        "idPuntoVenta": {
                                            "type": "number",
                                            "default": null
                                        }
                                    }
                                }]
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_AABB_ReservasRestaurant_Servicios_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/AABB/ReservasRestaurant/Servicios"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "idiomaBase": {
                                "type": "string"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "array",
                                "items": [{
                                    "type": "object",
                                    "properties": {
                                        "idServicio": {
                                            "type": "number",
                                            "default": null
                                        },
                                        "Servicio": {
                                            "type": "string"
                                        }
                                    }
                                }]
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_RESORT_SPA_ReservarSpa_put": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/RESORT/SPA/ReservarSpa"
            },
            "method": {
                "type": "string",
                "default": "put"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "tratamiento_id": {
                                "type": "number",
                                "default": null
                            },
                            "HoraInicio": {
                                "type": "string"
                            },
                            "Huesped": {
                                "type": "string"
                            },
                            "Observaciones": {
                                "type": "string"
                            },
                            "ApellidoNombre": {
                                "type": "string"
                            },
                            "FechaInicio": {
                                "type": "string"
                            },
                            "Habitacion": {
                                "type": "number",
                                "default": null
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "code": {
                                "type": "number",
                                "default": 200
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_RESORT_SPA_Dispo_Tratamientos_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/RESORT/SPA/Dispo_Tratamientos"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "HoraInicio": {
                                "type": "string"
                            },
                            "FechaInicio": {
                                "type": "string"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "array",
                                "items": [{
                                    "type": "object",
                                    "properties": {
                                        "tratamiento_id": {
                                            "type": "number",
                                            "default": null
                                        },
                                        "tratamiento": {
                                            "type": "string"
                                        }
                                    }
                                }]
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_AABB_Desayuno_ReservarDesayuno_put": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/AABB/Desayuno/ReservarDesayuno"
            },
            "method": {
                "type": "string",
                "default": "put"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "CantPersonas": {
                                "type": "number",
                                "default": null
                            },
                            "Huesped": {
                                "type": "string"
                            },
                            "Observaciones": {
                                "type": "string"
                            },
                            "idOpera": {
                                "type": "string"
                            },
                            "FechaDesde": {
                                "type": "string"
                            },
                            "Email": {
                                "type": "string"
                            },
                            "idRango": {
                                "type": "number",
                                "default": null
                            },
                            "FechaHasta": {
                                "type": "string"
                            },
                            "TelefonoContacto": {
                                "type": "string"
                            },
                            "FechaNacimiento": {
                                "type": "string"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "code": {
                                "type": "number",
                                "default": 200
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_RESORT_SPA_MisReservasSpa_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/RESORT/SPA/MisReservasSpa"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "idiomaBase": {
                                "type": "string"
                            },
                            "id_Opera": {
                                "type": "string"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "array",
                                "items": [{
                                    "type": "object",
                                    "properties": {
                                        "FechaInicio": {
                                            "type": "string"
                                        },
                                        "tratamiento": {
                                            "type": "string"
                                        },
                                        "HoraInicio": {
                                            "type": "string"
                                        },
                                        "Duracion": {
                                            "type": "number",
                                            "default": null
                                        },
                                        "Comentario": {
                                            "type": "string"
                                        },
                                        "Descripcion": {
                                            "type": "string"
                                        },
                                        "idReserva": {
                                            "type": "number",
                                            "default": null
                                        }
                                    }
                                }]
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_AABB_Cartas_Platos_Room_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/AABB/Cartas/Platos_Room"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "idiomaBase": {
                                "type": "string"
                            },
                            "id_plato": {
                                "type": "number",
                                "default": null
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "array",
                                "items": [{
                                    "type": "object",
                                    "properties": {
                                        "Titulo_Plato": {
                                            "type": "string"
                                        },
                                        "Precio": {
                                            "type": "number",
                                            "default": null
                                        },
                                        "Tipo_Plato": {
                                            "type": "string"
                                        },
                                        "id_Carta": {
                                            "type": "number",
                                            "default": null
                                        },
                                        "Activo": {
                                            "type": "number",
                                            "default": null
                                        },
                                        "id_PDV": {
                                            "type": "number",
                                            "default": null
                                        },
                                        "id_Tipo_Plato": {
                                            "type": "number",
                                            "default": null
                                        }
                                    }
                                }]
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_Varios_Controles_HorarioRoomService_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/Varios/Controles/HorarioRoomService"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "Tipo": {
                                "type": "string"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "object",
                                "properties": {
                                    "Habilitado": {
                                        "type": "string",
                                        "default": "true"
                                    }
                                }
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_AABB_Cartas_CartaCompleta_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/AABB/Cartas/CartaCompleta"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "idiomaBase": {
                                "type": "string"
                            },
                            "idPDV": {
                                "type": "number",
                                "default": null
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "array",
                                "items": [{
                                    "type": "object",
                                    "properties": {
                                        "Foto": {
                                            "type": "string",
                                            "default": "assets/images/Carta.jpg"
                                        },
                                        "id_PDV": {
                                            "type": "number",
                                            "default": 1
                                        },
                                        "Descripcion_Plato": {
                                            "type": "string"
                                        },
                                        "Tipo_Plato": {
                                            "type": "string",
                                            "default": "Postres"
                                        },
                                        "Activo": {
                                            "type": "number",
                                            "default": 1
                                        },
                                        "Titulo_Plato": {
                                            "type": "string",
                                            "default": "Helados Artesanales"
                                        },
                                        "id_Carta": {
                                            "type": "number",
                                            "default": 46
                                        },
                                        "Precio": {
                                            "type": "number",
                                            "default": 850
                                        }
                                    }
                                }]
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_RESORT_SPA_Spa_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/RESORT/SPA/Spa"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "id_Spa": {
                                "type": "number",
                                "default": null
                            },
                            "idiomaBase": {
                                "type": "string"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "array",
                                "items": [{
                                    "type": "object",
                                    "properties": {
                                        "Foto": {
                                            "type": "string"
                                        },
                                        "Descripcion": {
                                            "type": "string"
                                        },
                                        "Detalle": {
                                            "type": "string"
                                        },
                                        "Titulo": {
                                            "type": "string"
                                        },
                                        "Horario": {
                                            "type": "string"
                                        },
                                        "ClaseAppery": {
                                            "type": "string"
                                        },
                                        "id_Spa": {
                                            "type": "number",
                                            "default": null
                                        }
                                    }
                                }]
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HotelApp_user_update_service": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/db/users/{_id}"
            },
            "method": {
                "type": "string",
                "default": "put"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "Email": {
                                "type": "string"
                            },
                            "username": {
                                "type": "string"
                            },
                            "Titular": {
                                "type": "string"
                            },
                            "Huesped": {
                                "type": "string"
                            },
                            "Idioma": {
                                "type": "string"
                            },
                            "Departure": {
                                "type": "string"
                            },
                            "Tipo": {
                                "type": "string"
                            },
                            "password": {
                                "type": "string"
                            },
                            "acl": {
                                "type": "object",
                                "properties": {
                                    "*": {
                                        "type": "object",
                                        "properties": {
                                            "read": {
                                                "type": "boolean",
                                                "default": true
                                            },
                                            "write": {
                                                "type": "boolean",
                                                "default": true
                                            }
                                        }
                                    }
                                }
                            },
                            "Habitacion": {
                                "type": "string"
                            },
                            "TelefonoContacto": {
                                "type": "string"
                            },
                            "FechaNacimiento": {
                                "type": "string"
                            },
                            "Arrival": {
                                "type": "string"
                            },
                            "CantPersonas": {
                                "type": "number",
                                "default": null
                            },
                            "id_Opera": {
                                "type": "string"
                            },
                            "Titulo": {
                                "type": "string"
                            }
                        }
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "_id": {
                                "type": "string"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Session-Token": {
                                "type": "string"
                            },
                            "Content-Type": {
                                "type": "string",
                                "default": "application/json"
                            },
                            "X-Appery-Database-Id": {
                                "type": "string",
                                "default": "{HotelApp_settings.database_id}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "_updatedAt": {
                                "type": "string"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {}
                    }
                }
            }
        }
    },
    "HostGator_HostGator_AABB_Desayuno_HorariosDisponiblesDesayuno_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/AABB/Desayuno/HorariosDisponiblesDesayuno"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "FechaHasta": {
                                "type": "string"
                            },
                            "FechaDesde": {
                                "type": "string"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "array",
                                "items": [{
                                    "type": "object",
                                    "properties": {
                                        "idRango": {
                                            "type": "number",
                                            "default": null
                                        },
                                        "Rango": {
                                            "type": "string"
                                        }
                                    }
                                }]
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HotelApp_PDV_read_service": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/db/collections/PDV/{_id}"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "_id": {
                                "type": "string"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Database-Id": {
                                "type": "string",
                                "default": "{HotelApp_settings.database_id}"
                            },
                            "X-Appery-Session-Token": {
                                "type": "string"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "object",
                                "properties": {
                                    "Detalle": {
                                        "type": "string"
                                    },
                                    "acl": {
                                        "type": "object",
                                        "properties": {
                                            "*": {
                                                "type": "object",
                                                "properties": {
                                                    "read": {
                                                        "type": "boolean",
                                                        "default": true
                                                    },
                                                    "write": {
                                                        "type": "boolean",
                                                        "default": true
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    "_createdAt": {
                                        "type": "string"
                                    },
                                    "Horario": {
                                        "type": "string"
                                    },
                                    "PDV": {
                                        "type": "string"
                                    },
                                    "Descripcion": {
                                        "type": "string"
                                    },
                                    "Foto": {
                                        "type": "string"
                                    },
                                    "_id": {
                                        "type": "string"
                                    },
                                    "Activo": {
                                        "type": "number",
                                        "default": null
                                    },
                                    "idPDV": {
                                        "type": "string"
                                    },
                                    "_updatedAt": {
                                        "type": "string"
                                    }
                                }
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {}
                    }
                }
            }
        }
    },
    "HostGator_HostGator_AABB_Desayuno_CantPersonasDesayuno_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/AABB/Desayuno/CantPersonasDesayuno"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {}
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "array",
                                "items": [{
                                    "type": "object",
                                    "properties": {
                                        "idCantPersonas": {
                                            "type": "number",
                                            "default": null
                                        },
                                        "CantPersonas": {
                                            "type": "number",
                                            "default": null
                                        }
                                    }
                                }]
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_AABB_Desayuno_ConfirmarHorariosDesayuno_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/AABB/Desayuno/ConfirmarHorariosDesayuno"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "checkin": {
                                "type": "string"
                            },
                            "Observaciones": {
                                "type": "string"
                            },
                            "idOpera": {
                                "type": "string"
                            },
                            "checkout": {
                                "type": "string"
                            },
                            "Horario2": {
                                "type": "number",
                                "default": null
                            },
                            "Horario1": {
                                "type": "number",
                                "default": null
                            },
                            "Email": {
                                "type": "string"
                            },
                            "Huesped": {
                                "type": "string"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "object",
                                "properties": {
                                    "code": {
                                        "type": "number",
                                        "default": 200
                                    }
                                }
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_AABB_Desayuno_HorariosPreferencia1_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/AABB/Desayuno/HorariosPreferencia1"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {}
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "array",
                                "items": [{
                                    "type": "object",
                                    "properties": {
                                        "id": {
                                            "type": "number",
                                            "default": null
                                        },
                                        "Horario": {
                                            "type": "string"
                                        }
                                    }
                                }]
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_Varios_Controles_IdiomaMapas_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/Varios/Controles/IdiomaMapas"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "id_Mapa": {
                                "type": "number",
                                "default": null
                            },
                            "idiomaBase": {
                                "type": "string"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "array",
                                "items": [{
                                    "type": "object",
                                    "properties": {
                                        "Link": {
                                            "type": "string"
                                        },
                                        "ClaseAppery": {
                                            "type": "string"
                                        },
                                        "Titulo": {
                                            "type": "string"
                                        }
                                    }
                                }]
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_RESORT_RESORT_Tipo_Actividades_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/RESORT/RESORT/Tipo_Actividades"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "id_Actividad": {
                                "type": "number",
                                "default": null
                            },
                            "idiomaBase": {
                                "type": "string"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "array",
                                "items": [{
                                    "type": "object",
                                    "properties": {
                                        "ClaseAppery": {
                                            "type": "string"
                                        },
                                        "Descripcion": {
                                            "type": "string"
                                        },
                                        "id_Actividad": {
                                            "type": "number",
                                            "default": null
                                        },
                                        "Foto": {
                                            "type": "string"
                                        },
                                        "Horario": {
                                            "type": "string"
                                        },
                                        "Activo": {
                                            "type": "number",
                                            "default": null
                                        },
                                        "Titulo": {
                                            "type": "string"
                                        },
                                        "Detalle": {
                                            "type": "string"
                                        }
                                    }
                                }]
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_RESORT_SPA_Tipo_Tratamiento_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/RESORT/SPA/Tipo_Tratamiento"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "id_Tipo_Spa": {
                                "type": "number",
                                "default": null
                            },
                            "idiomaBase": {
                                "type": "string"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "array",
                                "items": [{
                                    "type": "object",
                                    "properties": {
                                        "Descripcion": {
                                            "type": "string"
                                        },
                                        "id_Tipo_Tratamiento": {
                                            "type": "number",
                                            "default": null
                                        },
                                        "Titulo": {
                                            "type": "string"
                                        },
                                        "ClaseApperyPrecio": {
                                            "type": "string"
                                        },
                                        "Precio": {
                                            "type": "number",
                                            "default": null
                                        },
                                        "ClaseAppery": {
                                            "type": "string"
                                        }
                                    }
                                }]
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_AABB_ReservasRestaurant_MisReservasResto_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/AABB/ReservasRestaurant/MisReservasResto"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "idiomaBase": {
                                "type": "string"
                            },
                            "id_Opera": {
                                "type": "string"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "array",
                                "items": [{
                                    "type": "object",
                                    "properties": {
                                        "Comentarios": {
                                            "type": "string"
                                        },
                                        "CodigoReserva": {
                                            "type": "string"
                                        },
                                        "idReserva": {
                                            "type": "number",
                                            "default": null
                                        },
                                        "CantPersonas": {
                                            "type": "number",
                                            "default": null
                                        },
                                        "PuntoVenta": {
                                            "type": "string"
                                        },
                                        "FechaReserva": {
                                            "type": "string"
                                        },
                                        "Descripcion": {
                                            "type": "string"
                                        },
                                        "HoraReserva": {
                                            "type": "string"
                                        }
                                    }
                                }]
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_RESORT_SPA_Tipo_Spa_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/RESORT/SPA/Tipo_Spa"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "idiomaBase": {
                                "type": "string"
                            },
                            "id_Tipo_Spa": {
                                "type": "number",
                                "default": null
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "array",
                                "items": [{
                                    "type": "object",
                                    "properties": {
                                        "ClaseAppery": {
                                            "type": "string"
                                        },
                                        "Foto": {
                                            "type": "string"
                                        },
                                        "Titulo": {
                                            "type": "string"
                                        },
                                        "id_Tipo_Spa": {
                                            "type": "number",
                                            "default": null
                                        },
                                        "Descripcion": {
                                            "type": "string"
                                        },
                                        "Detalle": {
                                            "type": "string"
                                        }
                                    }
                                }]
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_AABB_ReservasRestaurant_HorariosDisponibles_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/AABB/ReservasRestaurant/HorariosDisponibles"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "Fecha": {
                                "type": "string"
                            },
                            "CantPersonas": {
                                "type": "number",
                                "default": null
                            },
                            "idServicio": {
                                "type": "number",
                                "default": null
                            },
                            "idPuntoVenta": {
                                "type": "number",
                                "default": null
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "array",
                                "items": [{
                                    "type": "object",
                                    "properties": {
                                        "idRango": {
                                            "type": "number",
                                            "default": null
                                        },
                                        "Rango": {
                                            "type": "string"
                                        }
                                    }
                                }]
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_AABB_ReservasRestaurant_ReservarResto_put": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/AABB/ReservasRestaurant/ReservarResto"
            },
            "method": {
                "type": "string",
                "default": "put"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "idRango": {
                                "type": "number",
                                "default": null
                            },
                            "Observaciones": {
                                "type": "string"
                            },
                            "Habitacion": {
                                "type": "number",
                                "default": null
                            },
                            "idServicio": {
                                "type": "number",
                                "default": null
                            },
                            "idPDV": {
                                "type": "number",
                                "default": null
                            },
                            "Huesped": {
                                "type": "string"
                            },
                            "TelefonoContacto": {
                                "type": "string"
                            },
                            "FechaNacimiento": {
                                "type": "string"
                            },
                            "Email": {
                                "type": "string"
                            },
                            "CantPersonas": {
                                "type": "number",
                                "default": null
                            },
                            "idOpera": {
                                "type": "string"
                            },
                            "Fecha": {
                                "type": "string"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "code": {
                                "type": "number",
                                "default": 200
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_Varios_Controles_Secciones_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/Varios/Controles/Secciones"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "idiomaBase": {
                                "type": "string"
                            },
                            "idSeccion": {
                                "type": "number",
                                "default": null
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "array",
                                "items": [{
                                    "type": "object",
                                    "properties": {
                                        "Descripcion": {
                                            "type": "string"
                                        },
                                        "ClaseAppery": {
                                            "type": "string"
                                        },
                                        "id_Seccion": {
                                            "type": "number",
                                            "default": null
                                        },
                                        "Titulo": {
                                            "type": "string"
                                        }
                                    }
                                }]
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_AABB_ReservasRestaurant_CantPersonas_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/AABB/ReservasRestaurant/CantPersonas"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {}
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "array",
                                "items": [{
                                    "type": "object",
                                    "properties": {
                                        "idCantPersonas": {
                                            "type": "number",
                                            "default": null
                                        },
                                        "CantPersonas": {
                                            "type": "number",
                                            "default": null
                                        }
                                    }
                                }]
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_AABB_Cartas_Platos_x_PDV_y_Servicio_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/AABB/Cartas/Platos_x_PDV_y_Servicio"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "idServicio": {
                                "type": "string"
                            },
                            "idiomaBase": {
                                "type": "string"
                            },
                            "idTipoPlato": {
                                "type": "number",
                                "default": null
                            },
                            "idPDV": {
                                "type": "number",
                                "default": null
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "array",
                                "items": [{
                                    "type": "object",
                                    "properties": {
                                        "Precio": {
                                            "type": "string"
                                        },
                                        "ClaseAppery": {
                                            "type": "string"
                                        },
                                        "Foto": {
                                            "type": "string"
                                        },
                                        "SimboloPrecio": {
                                            "type": "string"
                                        },
                                        "id_Plato": {
                                            "type": "number",
                                            "default": null
                                        },
                                        "Descripcion_Plato": {
                                            "type": "string"
                                        },
                                        "id_PDV": {
                                            "type": "number",
                                            "default": null
                                        },
                                        "TipografiaDetalle": {
                                            "type": "string"
                                        },
                                        "celdaPrecio": {
                                            "type": "string"
                                        },
                                        "Titulo_Plato": {
                                            "type": "string"
                                        },
                                        "TipografiaTitulo": {
                                            "type": "string"
                                        }
                                    }
                                }]
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_AABB_Carro_hacerPedidoOpciones_post": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/AABB/Carro/hacerPedidoOpciones"
            },
            "method": {
                "type": "string",
                "default": "post"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "huesped": {
                                "type": "string"
                            },
                            "idPDV": {
                                "type": "number",
                                "default": null
                            },
                            "idUsu": {
                                "type": "string"
                            },
                            "id_opera": {
                                "type": "number",
                                "default": null
                            },
                            "idiomaBase": {
                                "type": "string"
                            },
                            "room": {
                                "type": "number",
                                "default": null
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "array",
                        "items": [{
                            "type": "object",
                            "properties": {
                                "insert_id": {
                                    "type": "number",
                                    "default": null
                                }
                            }
                        }]
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_AABB_Carro_totalCarroOpciones_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/AABB/Carro/totalCarroOpciones"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "idPDV": {
                                "type": "number",
                                "default": null
                            },
                            "idUsu": {
                                "type": "string"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "object",
                                "properties": {
                                    "Total": {
                                        "type": "string"
                                    }
                                }
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_AABB_Carro_listarCarroOpciones_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/AABB/Carro/listarCarroOpciones"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "idUsuario": {
                                "type": "string"
                            },
                            "idiomaBase": {
                                "type": "string"
                            },
                            "idPDV": {
                                "type": "number",
                                "default": null
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "array",
                                "items": [{
                                    "type": "object",
                                    "properties": {
                                        "cantidad": {
                                            "type": "number",
                                            "default": null
                                        },
                                        "Titulo_Plato": {
                                            "type": "string"
                                        },
                                        "Precio": {
                                            "type": "number",
                                            "default": null
                                        },
                                        "opciones": {
                                            "type": "string"
                                        }
                                    }
                                }]
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_AABB_Carro_ElCarroEstaVacioOpciones_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/AABB/Carro/ElCarroEstaVacioOpciones"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "id_usuario": {
                                "type": "string"
                            },
                            "idPDV": {
                                "type": "number",
                                "default": null
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "object",
                                "properties": {
                                    "cant": {
                                        "type": "string"
                                    },
                                    "vacio": {
                                        "type": "string",
                                        "default": "Error"
                                    }
                                }
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_AABB_Carro_listarPedidosOpciones_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/AABB/Carro/listarPedidosOpciones"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "idOpera": {
                                "type": "number",
                                "default": null
                            },
                            "idiomaBase": {
                                "type": "string"
                            },
                            "idPDV": {
                                "type": "number",
                                "default": null
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "array",
                                "items": [{
                                    "type": "object",
                                    "properties": {
                                        "color": {
                                            "type": "string"
                                        },
                                        "total": {
                                            "type": "number",
                                            "default": null
                                        },
                                        "estado_EN": {
                                            "type": "string"
                                        },
                                        "id_pedido": {
                                            "type": "string"
                                        },
                                        "Fecha": {
                                            "type": "string"
                                        },
                                        "titulo": {
                                            "type": "string"
                                        },
                                        "Hora": {
                                            "type": "string"
                                        }
                                    }
                                }]
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_AABB_Carro_addToCartOpciones_put": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/AABB/Carro/addToCartOpciones"
            },
            "method": {
                "type": "string",
                "default": "put"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "opcionF": {
                                "type": "number",
                                "default": null
                            },
                            "opcionE": {
                                "type": "number",
                                "default": null
                            },
                            "idPlato": {
                                "type": "number",
                                "default": null
                            },
                            "cant": {
                                "type": "number",
                                "default": null
                            },
                            "opcionD": {
                                "type": "number",
                                "default": null
                            },
                            "idPDV": {
                                "type": "number",
                                "default": null
                            },
                            "idUsu": {
                                "type": "string"
                            },
                            "opcionC": {
                                "type": "number",
                                "default": null
                            },
                            "opcionA": {
                                "type": "number",
                                "default": null
                            },
                            "opcionB": {
                                "type": "number",
                                "default": null
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "Branch3": {
                                "type": "object",
                                "properties": {
                                    "inserted_id": {
                                        "type": "string",
                                        "default": "1"
                                    }
                                }
                            },
                            "Branch6": {
                                "type": "object",
                                "properties": {
                                    "inserted_id": {
                                        "type": "string",
                                        "default": "1"
                                    }
                                }
                            },
                            "Branch5": {
                                "type": "object",
                                "properties": {
                                    "inserted_id": {
                                        "type": "string",
                                        "default": "1"
                                    }
                                }
                            },
                            "Branch2": {
                                "type": "object",
                                "properties": {
                                    "inserted_id": {
                                        "type": "string",
                                        "default": "1"
                                    }
                                }
                            },
                            "Branch4": {
                                "type": "object",
                                "properties": {
                                    "inserted_id": {
                                        "type": "string",
                                        "default": "1"
                                    }
                                }
                            },
                            "Branch1": {
                                "type": "object",
                                "properties": {
                                    "inserted_id": {
                                        "type": "string",
                                        "default": "1"
                                    }
                                }
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_AABB_Carro_borrarCarroOpciones_delete": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/AABB/Carro/borrarCarroOpciones"
            },
            "method": {
                "type": "string",
                "default": "delete"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "idPDV": {
                                "type": "number",
                                "default": null
                            },
                            "idUsu": {
                                "type": "string"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "array",
                                "items": [{
                                    "type": "string"
                                }]
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_RESORT_RESORT_ReservarActividad_New_put": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/RESORT/RESORT/ReservarActividad_New"
            },
            "method": {
                "type": "string",
                "default": "put"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "FechaInicio": {
                                "type": "string"
                            },
                            "FechaCheckOut": {
                                "type": "string"
                            },
                            "TelefonoContacto": {
                                "type": "string"
                            },
                            "id_actividad": {
                                "type": "number",
                                "default": null
                            },
                            "Email": {
                                "type": "string"
                            },
                            "Tipo": {
                                "type": "string"
                            },
                            "ApellidoNombre": {
                                "type": "string"
                            },
                            "CantPersonas": {
                                "type": "number",
                                "default": null
                            },
                            "Observaciones": {
                                "type": "string"
                            },
                            "Habitacion": {
                                "type": "number",
                                "default": null
                            },
                            "Huesped": {
                                "type": "string"
                            },
                            "FechaCheckIn": {
                                "type": "string"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "code": {
                                "type": "number",
                                "default": 200
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_AABB_Desayuno_MisReservasDesayuno_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/AABB/Desayuno/MisReservasDesayuno"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "idiomaBase": {
                                "type": "string"
                            },
                            "id_Opera": {
                                "type": "string"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "array",
                                "items": [{
                                    "type": "object",
                                    "properties": {
                                        "Comentarios": {
                                            "type": "string"
                                        },
                                        "CantPersonas": {
                                            "type": "number",
                                            "default": null
                                        },
                                        "idReserva": {
                                            "type": "number",
                                            "default": null
                                        },
                                        "PuntoVenta": {
                                            "type": "string"
                                        },
                                        "Descripcion": {
                                            "type": "string"
                                        },
                                        "CodigoReserva": {
                                            "type": "string"
                                        },
                                        "FechaReserva": {
                                            "type": "string"
                                        },
                                        "HoraReserva": {
                                            "type": "string"
                                        }
                                    }
                                }]
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_AABB_ReservasRestaurant_ReservarRestoNew_put": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/AABB/ReservasRestaurant/ReservarRestoNew"
            },
            "method": {
                "type": "string",
                "default": "put"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "idPDV": {
                                "type": "number",
                                "default": null
                            },
                            "FechaCheckOut": {
                                "type": "string"
                            },
                            "Tipo": {
                                "type": "string"
                            },
                            "FechaNacimiento": {
                                "type": "string"
                            },
                            "TelefonoContacto": {
                                "type": "string"
                            },
                            "Fecha": {
                                "type": "string"
                            },
                            "idOpera": {
                                "type": "string"
                            },
                            "idServicio": {
                                "type": "number",
                                "default": null
                            },
                            "Huesped": {
                                "type": "string"
                            },
                            "Email": {
                                "type": "string"
                            },
                            "Observaciones": {
                                "type": "string"
                            },
                            "FechaCheckIn": {
                                "type": "string"
                            },
                            "idRango": {
                                "type": "number",
                                "default": null
                            },
                            "CantPersonas": {
                                "type": "number",
                                "default": null
                            },
                            "Habitacion": {
                                "type": "number",
                                "default": null
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "code": {
                                "type": "number",
                                "default": 200
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_AABB_Carro_hacerPedido_post": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/AABB/Carro/hacerPedido"
            },
            "method": {
                "type": "string",
                "default": "post"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "idUsu": {
                                "type": "string"
                            },
                            "idiomaBase": {
                                "type": "string"
                            },
                            "id_opera": {
                                "type": "number",
                                "default": null
                            },
                            "room": {
                                "type": "number",
                                "default": null
                            },
                            "idPDV": {
                                "type": "number",
                                "default": null
                            },
                            "huesped": {
                                "type": "string"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "array",
                        "items": [{
                            "type": "object",
                            "properties": {
                                "insert_id": {
                                    "type": "number",
                                    "default": null
                                }
                            }
                        }]
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_AABB_Carro_ElCarroEstaVacio_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/AABB/Carro/ElCarroEstaVacio"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "id_usuario": {
                                "type": "string"
                            },
                            "idPDV": {
                                "type": "number",
                                "default": null
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "object",
                                "properties": {
                                    "vacio": {
                                        "type": "string",
                                        "default": "Error"
                                    },
                                    "cant": {
                                        "type": "string"
                                    }
                                }
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_AABB_Carro_borrarCarro_delete": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/AABB/Carro/borrarCarro"
            },
            "method": {
                "type": "string",
                "default": "delete"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "idPDV": {
                                "type": "number",
                                "default": null
                            },
                            "idUsu": {
                                "type": "string"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "array",
                                "items": [{
                                    "type": "string"
                                }]
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_AABB_Cartas_Servicios_x_PDV_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/AABB/Cartas/Servicios_x_PDV"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "idServicio": {
                                "type": "number",
                                "default": null
                            },
                            "idiomaBase": {
                                "type": "string"
                            },
                            "idPDV": {
                                "type": "number",
                                "default": null
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "array",
                                "items": [{
                                    "type": "object",
                                    "properties": {
                                        "Horario": {
                                            "type": "string"
                                        },
                                        "activo": {
                                            "type": "string"
                                        },
                                        "id_Servicio": {
                                            "type": "number",
                                            "default": null
                                        },
                                        "Servicio": {
                                            "type": "string"
                                        },
                                        "Foto": {
                                            "type": "string"
                                        }
                                    }
                                }]
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_AABB_Carro_listarPedidos_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/AABB/Carro/listarPedidos"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "idPDV": {
                                "type": "number",
                                "default": null
                            },
                            "idOpera": {
                                "type": "string"
                            },
                            "idiomaBase": {
                                "type": "string"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "array",
                                "items": [{
                                    "type": "object",
                                    "properties": {
                                        "titulo": {
                                            "type": "string"
                                        },
                                        "Hora": {
                                            "type": "string"
                                        },
                                        "Fecha": {
                                            "type": "string"
                                        },
                                        "estado_EN": {
                                            "type": "string"
                                        },
                                        "total": {
                                            "type": "number",
                                            "default": null
                                        },
                                        "id_pedido": {
                                            "type": "string"
                                        },
                                        "color": {
                                            "type": "string"
                                        }
                                    }
                                }]
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_AABB_Carro_totalCarro_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/AABB/Carro/totalCarro"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "idPDV": {
                                "type": "number",
                                "default": null
                            },
                            "idUsu": {
                                "type": "string"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "array",
                                "items": [{
                                    "type": "object",
                                    "properties": {
                                        "total": {
                                            "type": "number",
                                            "default": null
                                        }
                                    }
                                }]
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_AABB_Carro_listarCarro_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/AABB/Carro/listarCarro"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "idiomaBase": {
                                "type": "string"
                            },
                            "idPDV": {
                                "type": "number",
                                "default": null
                            },
                            "idUsuario": {
                                "type": "string"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "array",
                                "items": [{
                                    "type": "object",
                                    "properties": {
                                        "cantidad": {
                                            "type": "number",
                                            "default": null
                                        },
                                        "Titulo_Plato": {
                                            "type": "string"
                                        },
                                        "Precio": {
                                            "type": "number",
                                            "default": null
                                        }
                                    }
                                }]
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_RESORT_RESORT_Resort_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/RESORT/RESORT/Resort"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "idiomaBase": {
                                "type": "string"
                            },
                            "id_Resort": {
                                "type": "number",
                                "default": null
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "array",
                                "items": [{
                                    "type": "object",
                                    "properties": {
                                        "Foto": {
                                            "type": "string"
                                        },
                                        "id_Resort": {
                                            "type": "number",
                                            "default": null
                                        },
                                        "Descripcion": {
                                            "type": "string"
                                        },
                                        "Titulo": {
                                            "type": "string"
                                        },
                                        "Horario": {
                                            "type": "string"
                                        },
                                        "Detalle": {
                                            "type": "string"
                                        },
                                        "ClaseAppery": {
                                            "type": "string"
                                        },
                                        "Link": {
                                            "type": "string"
                                        }
                                    }
                                }]
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_RESORT_RESORT_ReservarActividad_put": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/RESORT/RESORT/ReservarActividad"
            },
            "method": {
                "type": "string",
                "default": "put"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "TelefonoContacto": {
                                "type": "string"
                            },
                            "id_actividad": {
                                "type": "number",
                                "default": null
                            },
                            "CantPersonas": {
                                "type": "number",
                                "default": null
                            },
                            "ApellidoNombre": {
                                "type": "string"
                            },
                            "Observaciones": {
                                "type": "string"
                            },
                            "FechaInicio": {
                                "type": "string"
                            },
                            "Huesped": {
                                "type": "string"
                            },
                            "Habitacion": {
                                "type": "number",
                                "default": null
                            },
                            "Email": {
                                "type": "string"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "code": {
                                "type": "number",
                                "default": 200
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_RESORT_RESORT_MisReservasActividades_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/RESORT/RESORT/MisReservasActividades"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "id_Opera": {
                                "type": "string"
                            },
                            "idiomaBase": {
                                "type": "string"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "array",
                                "items": [{
                                    "type": "object",
                                    "properties": {
                                        "adultos": {
                                            "type": "number",
                                            "default": null
                                        },
                                        "Aviso": {
                                            "type": "string"
                                        },
                                        "FechaInicio": {
                                            "type": "string"
                                        },
                                        "menores": {
                                            "type": "number",
                                            "default": null
                                        },
                                        "comentarios": {
                                            "type": "string"
                                        },
                                        "id_actividad": {
                                            "type": "number",
                                            "default": null
                                        },
                                        "HoraInicio": {
                                            "type": "string"
                                        },
                                        "id_reserva": {
                                            "type": "number",
                                            "default": null
                                        },
                                        "idEstado": {
                                            "type": "number",
                                            "default": null
                                        },
                                        "actividad": {
                                            "type": "string"
                                        },
                                        "Descripcion": {
                                            "type": "string"
                                        },
                                        "CantPersonas": {
                                            "type": "number",
                                            "default": null
                                        }
                                    }
                                }]
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    },
    "HostGator_HostGator_RESORT_RESORT_ActividadesDisponibles_get": {
        "type": "object",
        "properties": {
            "url": {
                "type": "string",
                "default": "https://api.appery.io/rest/1/apiexpress/api/HostGator/RESORT/RESORT/ActividadesDisponibles"
            },
            "method": {
                "type": "string",
                "default": "get"
            },
            "request": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {}
                    },
                    "query": {
                        "type": "object",
                        "properties": {
                            "Fecha": {
                                "type": "string"
                            },
                            "id_Tipo_Actividad": {
                                "type": "number",
                                "default": null
                            },
                            "CantPersonas": {
                                "type": "number",
                                "default": null
                            },
                            "idiomaBase": {
                                "type": "string"
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "X-Appery-Api-Express-Api-Key": {
                                "type": "string",
                                "default": "{HostGator_settings.API_EXPRESS_API_KEY}"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "body": {
                        "type": "object",
                        "properties": {
                            "$": {
                                "type": "array",
                                "items": [{
                                    "type": "object",
                                    "properties": {
                                        "actividad": {
                                            "type": "string"
                                        },
                                        "id_actividad": {
                                            "type": "number",
                                            "default": null
                                        }
                                    }
                                }]
                            }
                        }
                    },
                    "headers": {
                        "type": "object",
                        "properties": {
                            "Content-Type": {
                                "type": "string"
                            }
                        }
                    }
                }
            }
        }
    }
};
/**
 * Data storage
 */
export const _aioDefStorageValues = {
    variables: {
    },
    storages: {
    },
    functions: {
    }
}